var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2655_29785)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86627 0.0596007C5.30407 0.0633949 5.65589 0.421372 5.6521 0.859166L5.62415 4.08435L12.6836 4.02316C13.3143 4.02316 13.9192 4.27375 14.3652 4.71975C14.8112 5.16574 15.0618 5.77064 15.0618 6.40137V13.5359H18.2327C18.6705 13.5359 19.0254 13.8908 19.0254 14.3286C19.0254 14.7664 18.6705 15.1213 18.2327 15.1213H15.0618V18.2922C15.0618 18.73 14.7069 19.085 14.269 19.085C13.8312 19.085 13.4763 18.73 13.4763 18.2922V15.1213H6.3418C5.71107 15.1213 5.10617 14.8708 4.66017 14.4248C4.21418 13.9788 3.96362 13.3739 3.96362 12.7432V12.7363L4.02478 5.68372L0.799595 5.71167C0.361802 5.71546 0.00382463 5.36364 3.04017e-05 4.92584C-0.00376378 4.48805 0.348062 4.13007 0.785855 4.12628L4.03852 4.09809L4.06671 0.845426C4.0705 0.407632 4.42848 0.0558065 4.86627 0.0596007ZM5.6104 5.66997L5.54908 12.746C5.54983 12.9552 5.63326 13.1557 5.78126 13.3037C5.92992 13.4524 6.13155 13.5359 6.3418 13.5359H13.4763V6.40137C13.4763 6.19112 13.3928 5.98949 13.2441 5.84083C13.0961 5.69283 12.8957 5.6094 12.6864 5.60865L5.6104 5.66997Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2655_29785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0254,
    height: 19.0254,
    fill: "white",
    transform: "translate(0 0.0595703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.42a8ab0f428ac5bff5fb906d5fc14cec.svg";
export { ForwardRef as ReactComponent };